import { render, staticRenderFns } from "./AccountRegistrationModal.vue?vue&type=template&id=6b5d1629&scoped=true"
import script from "./AccountRegistrationModal.vue?vue&type=script&lang=js"
export * from "./AccountRegistrationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5d1629",
  null
  
)

export default component.exports